import { StringParam, QueryParamConfig } from "use-query-params";

export const makeFieldParam = <Values extends string>() => {
  return StringParam as QueryParamConfig<Values | null | undefined>;
};
